<template>
  <!-- 新增或修改表单开始 -->
  <div>
    <el-dialog
      :title="news.id == 0 ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="visible"
      @close="dialogClose"
    >
      <el-form
        ref="news"
        :model="news"
        :rules="newsRules"
        label-width="80px"
        @keyup.enter.native="newsSubmit()"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="news.title"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="news.description"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="作者">
          <el-input v-model="news.author"></el-input>
        </el-form-item>
        <el-form-item label="来源">
          <el-input v-model="news.origin"></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="releaseTime">
          <el-date-picker
            v-model="news.releaseTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="活动赛事">
                    <el-select
                        v-model="news.activityId"
                        width="100"
                        clearable
                        :placeholder="news.activityName"
                    >
                        <el-option
                            v-for="item in activitiesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item label="新闻栏目" prop="categoryId">
          <el-select
            v-model="news.categoryId"
            width="100"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="活动图片"
          prop="activityImages"
          v-if="news.categoryId == '1008'"
        >
          <!-- <el-form-item label="图片链接"> -->
          <img-upload
            @imgUploaded="imgUploaded"
            @removeImg="removeImg"
            :imgList="preImg"
          />
          <!-- </el-form-item> -->
          <!-- <el-select
            v-model="news.area"
            width="100" 
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in area"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="新闻内容" prop="content">
          <el-button
            type="info"
            icon="el-icon-edit"
            size="small"
            @click="openRichDialog"
            >前往编写新闻内容</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="新闻图片">
          <el-upload
            class="upload"
            ref="upload"
            :action="uploadUrl"
            name="file"
            :limit="1"
            accept=".png,.jpg"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >

            <div slot="tip" class="el-upload__tip">
              只能上传 .png .jpg图片，且不超过10MB
            </div>
          </el-upload>
        </el-form-item> -->

        <el-form-item label="附件文件">
          <video-upload
            ref="videoUploaded"
            @videoUploaded="videoUploaded"
            @removeVideo="removeVideo"
            :videoList="preVideo"
          />
        </el-form-item>
        <el-form-item label="附件外链">
          <el-input
            v-model="news.enclosure"
            placeholder="请输入新闻外链"
            @input="isHaveVideo"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="内容">
                         <Editor></Editor>
                     </el-form-item> -->

        <el-form-item>
          <!-- <el-button type="primary" @click="newsSubmit">
                        <i v-if="news.id">
                            添加新闻内容
                        </i>
                        <i v-else>
                            修改新闻内容
                        </i>
                    </el-button> -->
          <el-button type="primary" @click="newsSubmit">保存</el-button>
          <el-button @click="visiblee">取消</el-button>
        </el-form-item>
      </el-form>
      <!-- 内层对话框 -->
      <el-dialog
        width="50%"
        title="活动内容"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div id="demo1"></div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="innerVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-dialog>
  </div>
  <!-- 新增或修改表单结束 -->
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
import VideoUpload from "@/views/modules/config/child-components/upload-test";
import ImgUpload from "@/views/modules/config/child-components/upload-img";
export default {
  components: {
    // Editor
    VideoUpload,
    ImgUpload,
  },

  data() {
    return {
      preImg: [],
      // 外层对话框的显示与隐藏
      visible: false,
      // 节流阀
      shake: true,
      value1: "",
      news: {
        title: "",
        description: "",
        categoryId: "",
        content: "",
        enclosure: "",
        releaseTime: "",
      },
      // 新闻分类
      categories: [],
      area: [
        {
          name: "国家级",
          id: 0,
        },
        {
          name: "省级",
          id: 1,
        },
      ],
      a:[],
      uploadUrl: "",
      fileList: [],
      preVideo: [],
      // 内层对话框的显示与隐藏
      innerVisible: false,
      editor: null,
      // 查询赛事列表参数
      activitiesQuery: {
        limit: 10,
        page: 1,
        checkStatus: "",
      },
      activitiesList: [], //活动赛事列表
      newsRules: {
        title: [
          { required: true, message: "新闻标题不能为空", trigger: "blur" },
        ],
        categoryId: [
          { required: true, message: "新闻栏目不能为空", trigger: "blur" },
        ],
        content: [
          { required: true, message: "新闻内容不能为空", trigger: "blur" },
        ],
        releaseTime: [
          { required: true, message: "发布时间不能为空", trigger: "blur" },
        ],
      },
    };
  },

  activated() {
    this.getCategories();
  },
  methods: {
    visiblee(){
      this.visible = false
      this.preVideo = []
    },
    // 图片上传完成
    imgUploaded(url) {
      // console.log(url);
      // debugger
      
      this.preImg.push({
        url,
      });
      this.a = []
      this.preImg.forEach((e) => {
        this.a.push(e.url);
      });
      this.news.activityImages = this.a.toString();
    },
    removeImg(url) {
      // this.news.activityImages = "";
      // console.log(url);
      this.preImg = url;
      this.a = []
      this.preImg.forEach((e) => {
        this.a.push(e.url);
      });
      this.news.activityImages = this.a.toString();
      // return
      //  this.preImg.splice(index.index, 1)
      // this.news.activityImages = "";
    },
    showcontent,
    init(id) {
      this.news.id = id || 0;
      if (this.news.id == 0) {
        this.preVideo = []
      }
      this.visible = true;
      this.getCategories();
      this.$nextTick(() => {
        this.$refs["news"].resetFields();
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
        if (this.news.id) {
          this.$http({
            url: this.$http.adornUrl(`/news/open/${this.news.id}`),
            method: "get",
            params: this.$http.adornParams(),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              // console.log(data);
              // debugger
              // let dataa = JSON.stringify(data.data);
              // this.news = JSON.parse(
              //   // dataa
              //   showcontent(dataa)
              // );
              data.data.content = showcontent(data.data.content);
              data.data.description = showcontent(data.data.description);
              data.data.origin = showcontent(data.data.origin);
              data.data.author = showcontent(data.data.author);
              data.data.title = showcontent(data.data.title);
              this.news = data.data;
              if (this.news.activityImages) {
                // debugger
                // const obj = {};
                let a = [];
                a = this.news.activityImages.split(",");
                for (const key in a) {
                  let parm = {};
                  parm.url = a[key];
                  this.preImg.push(parm);
                }
                //  a.forEach((e) => {
                //     obj.url = e;
                //   });
                //   this.preImg.push(obj);
              }
              // console.log(this.preImg);
              // if (this.news.thumb) {
              //   const obj = {
              //     url: this.news.thumb,
              //   };
              //   this.fileList = [obj];
              // }
              if (this.news.enclosure) {
                this.preVideo = [{ url: this.news.enclosure }];
              }
            }
          });
        }
      });
    },
    // 视频上传完成
    videoUploaded(url, name) {
      // console.log(1,name);
      this.news.enclosureName = name;
      // debugger
      // console.log(this.videoList);
      if (this.news.enclosure != undefined && this.news.enclosure != "") {
        this.$refs.videoUploaded.clearFiles();
        this.$message({
          title: "错误",
          type: "error",
          message: "视频外链已上传，请删除后选择文件上传",
        });
      } else {
        this.news.enclosure = url;
      }
    },
    // 关闭对话框触发事件
    courseDialogClose() {
      this.$refs["news"].resetFields();
      Object.keys(this.news).forEach((item) => {
        if (item === "id") {
          this.news[item] = null;
        } else if (item === "sort") {
          this.news[item] = 0;
        } else {
          this.news[item] = "";
        }
      });
      (this.news = {
        title: "",
        description: "",
        categoryId: "",
        content: "",
        enclosure: "",
        releaseTime: "",
      }),
        (this.preVideo = []);
      this.preImg = [];
    },
    //获取赛事活动名称列表
    getActivitiesList() {
      // this.loading = true;
      this.$ajaxPost("/activities/listsys/open", this.activitiesQuery).then(
        ({ data }) => {
          // console.log(data, "活动赛事");
          if (data.code === 0) {
            // this.activitiesList = data.data;
            // this.loading = false;
            this.activitiesList = data.data.records;
            // this.activitiesTotal = parseInt(data.data.total);
          }
        }
      );
    },
    isHaveVideo() {
      // console.log(this.news.enclosure);
      if (this.news.enclosure != "") {
        // this.$message({
        //   title: "错误",
        //   type: "error",
        //   message: "视频外链已上传，请删除后选择文件上传",
        // });
      }
    },
    // 移除上传的视频
    removeVideo() {
      this.news.enclosure = "";
    },
    // 提交数据
    newsSubmit() {
      let that = this;
      // let shake = true;
      that.$refs.news.validate((valid) => {
        // console.log(that.news.releaseTime);
        // debugger
        if (valid) {
          if (that.shake) {
            that.shake = false;
            let news = { ...that.news };
            if (that.news.id == undefined || that.news.id == 0) {
              news.showStatus = 0;
            }
            that
              .$http({
                url: that.$http.adornUrl(
                  `/news/${that.news.id == 0 ? "save" : "update"}`
                ),
                method: "post",
                data: that.$http.adornData(
                  {
                    ...news,
                    id:
                      that.news.id == undefined || that.news.id == 0
                        ? null
                        : that.news.id,
                    // title: this.news.title,
                    // author: this.news.author,

                    // categoryId: this.news.categoryId,
                    // description: this.news.description,
                    // origin: this.news.origin,
                    // thumb: this.news.thumb,
                    // content: this.news.content,
                    // // showStatus: 1,
                  },
                  false
                ),
              })
              .then(({ data }) => {
                if (data.code != 0) {
                  that.shake = true;
                  this.$message({
                    title: "错误",
                    type: "error",
                    message: data.msg,
                  });
                } else {
                  that.visible = false;
                  that.shake = true;
                  that.preImg = [];
                  that.news = {
                    title: "",
                    description: "",
                    categoryId: "",
                    content: "",
                    enclosure: "",
                    releaseTime: "",
                  };
                  that.$emit("newsUpdateList");
                }
                // that.news = {};              // 添加或更新后从新获取新闻列表
              })
              .catch((err) => {
                this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
                  confirmButtonText: "确定",
                  type: "error",
                });
                that.shake = true;
              });
          } else {
            that.$message.error("操作频繁，请稍后再试");
          }
        } else {
          return false;
        }
      });
      // 更新新闻的数据
    },

    // 获取新闻栏目信息
    getCategories() {
      this.$http({
        url: this.$http.adornUrl("/category/list/EC000103"),
        method: "get",
      }).then(({ data }) => {
        // console.log("新闻栏目：", data.data);
        this.categories = data.data;
        this.getActivitiesList();
      });
    },
    // 打开对话框的时候创建富文本编辑器实例
    openRichDialog() {
      this.innerVisible = true;
      if (!this.editor) {
        this.$nextTick(() => {
          // 创建富文本编辑器实例
          const editor = new wangEditor("#demo1");
          // 配置 onchange 回调函数，将数据同步到 vue 中
          editor.config.onchange = (newHtml) => {
            this.news.content = newHtml;
          };
          editor.config.uploadImgServer = this.uploadUrl;
          editor.config.showLinkImg = false;
          editor.selection.getSelectionText(
            editor.selection.getSelectionContainerElem()
          );
          editor.config.uploadFileName = "file";
          /* editor.config.customUploadImg = function (
                        resultFiles,
                        insertImgFn
                    ) {
                        let objectURL = URL.createObjectURL(resultFiles[0]);
                        insertImgFn(objectURL);
                    }; */
          editor.config.uploadImgHooks = {
            customInsert: function (insertImg, result, editor) {
				
				    // console.log(result);
              let url = (result.data.fileInfo.domain ? result.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+result.data.fileInfo.file_path;
              insertImg(url);
            },
          };
          // 创建编辑器
          editor.create();
          if (this.news.content !== "") {
            editor.txt.html(showcontent(this.news.content));
          }
          this.editor = editor;
        });
      }
    },
    // ================================================文件上传相关方法=======================================
    // 从本地保存的上传目录中删除图片路径
    handleRemove(file, fileList) {
      this.news.thumb = "";
    },
    handlePreview(file) {
      // console.log(file);
      window.open(file.url, "_blank").location;
    },
    handlePreview1(file) {
      // console.log(file);
      // window.open(file.url, "_blank").location;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 10;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt100M;
    },
    handleSuccess(response) {
      if (response && response.code === 0) {
        // console.log("文件上传成功返回结果：", response.data);
	    let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
        this.news.thumb = url;
      }
    },
    // 对话框关闭的时候对表单进行重置
    dialogClose() {
      this.fileList = [];
      this.preImg = [];
      // this.news = {};
      this.news = {
        title: "",
        description: "",
        categoryId: "",
        content: "",
        enclosure: "",
        releaseTime: "",
      };
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-upload-list--picture {
  .el-upload-list__item {
    width: 92px;
    height: 92px;
  }
}
</style>